// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__4Psux","spinner":"Loader_spinner__mGV-x","spinner-d3wgkg":"Loader_spinner-d3wgkg__8t9Yi"};